<template>
  <b-card class="shipment">
    <template slot="header">
      <h6 class="mb-0">Shipment {{ index }}</h6>
      <b-button
        class="item_remove_button"
        variant="danger"
        size="sm"
        @click="deleteShipment"
        >Delete</b-button
      >
    </template>
    <b-card-text>
      <div class="shipment_item" v-for="item in shipment.items" :key="item.id">
        <div>{{ item.name }}</div>
        <b-button
          class="item_remove_button"
          variant="danger"
          size="sm"
          @click="unallocated(item.id)"
          >Remove</b-button
        >
      </div>
    </b-card-text>
    <template slot="footer">
      <form @submit.prevent="scanItem(scanModel)" style="width:100%">
        <div>
          <input
            ref="model"
            type="text"
            class="form-control text-uppercase"
            id="model"
            placeholder="item model"
            name="model"
            v-model="scanModel"
          />
        </div>
        <button
          type="submit"
          class="btn btn-light"
          style="display:none;"
        ></button>
      </form>
      <!-- <b-button variant="success" size="sm">Add</b-button> -->
    </template>
  </b-card>
</template>
<script>
export default {
  props: ["shipment", "index"],
  name: "shipment",
  components: {},
  data() {
    return {
      scanModel: ""
    };
  },
  methods: {
    deleteShipment() {
      this.$emit("delete", this.shipment.id);
    },
    unallocated(itemId) {
      this.$emit("unallocate", {
        item_id: itemId,
        shipment_id: this.shipment.id
      });
    },
    scanItem(model) {
      this.$emit("scan", { model: model, shipment_id: this.shipment.id });
      this.scanModel = "";
    }
  }
};
</script>
<style lang="scss" scoped>
.item_remove_button {
  height: 30px;
  padding: 2px 8px;
  line-height: 10px;
}
.shipment_item {
  width: 100%;
  border: 1px solid #ccc;
  padding: 10px 20px;
  margin-bottom: 7px;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.shipment .card-footer {
  display: flex;
  justify-content: space-between;
}
.shipment .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.shipment {
  margin-bottom: 15px;
}
</style>
